import { useDispatch } from 'react-redux';
import './css/app.css'
import './css/common.css'
import './css/main.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchInput, SearchInputBtn, SearchExcelBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { SquareX } from 'lucide-react';

function FeeNotice() {
    let dispatch = useDispatch()
    let navigate = useNavigate();
    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(20)
    const [loading, setLoading] = useState(true)
    const [tabBtn, setTabBtn] = useState(0)
    const [modal, setModal] = useState(false)

    const [message, setMessage] = useState("")
    const [listData, setListData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)
    // 현재 클릭한(수정/확인할) 데이터
    const [clickData, setClickData] = useState([])

    // 파일 업로드 관련 state
    const [imagePreview, setImagePreview] = useState(null);
    const [imageFile, setImageFile] = useState(null);
    // 업로드할 날짜 (YYYY-MM 형태, 서버 전송 시 YYYYMM 변환)
    const [uploadDate, setUploadDate] = useState('');

    const fileInputRef = useRef(null);

    // 페이지 진입 시 처리
    useEffect(() => {
        dispatch(change_Current_Location("수수료안내"))
        dispatch(changeHeaderTitle({
            mainTitle: "리스크 관리",
            subTitle: "수수료안내"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChange = (event) => {
        setMaxFirstPage(Number(event.target.value));
    };

    const tableHeaderData = [
        { "no": 1, "text": "NO", "width": "80px", "textAlign": "center" },
        { "no": 2, "text": "등록날짜", "width": "120px", "textAlign": "center" },
        { "no": 3, "text": "이미지명", "width": "250px", "textAlign": "center" },
        { "no": 4, "text": "PG", "width": "120px", "textAlign": "center" },
        { "no": 5, "text": "삭제여부", "width": "80px", "textAlign": "center" }
    ];

    // 한 페이지당 보여지는 개수만큼 배열 자르기
    let filter_tableBodyData = combineData.slice((page - 1) * maxFirstPage, page * maxFirstPage)

    // 목록 데이터 불러오기
    useEffect(() => {
        ListData()
    }, [page, maxFirstPage, reload])

    const ListData = async () => {
        await axios.get(process.env.REACT_APP_API + "/api/card-fee", {
            withCredentials: true,
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp)
                setListData(tmp?.data ?? [])
            } else if (tmp?.code === 9999) {
                navigate('/')
            }
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    // 테이블 렌더링용 데이터 생성
    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            let list = listData ?? []
            for (let i = 0; i < list.length; i++) {
                let data = list[i]

                tableBodyData.push([
                    {
                        no: 1,
                        text: maxFirstPage * (page - 1) + i + 1,
                        width: "80px",
                        textAlign: "center"
                    },
                    {
                        no: 2,
                        text: `${data?.date?.slice(0, 4) ?? "YYYY"}-${data?.date?.slice(4) ?? "MM"}`,
                        width: "120px",
                        textAlign: "center"
                    },
                    {
                        no: 3,
                        // 이미지명 클릭 시 clickData 저장 + 미리보기 세팅
                        text: (
                            <div
                                className='pointer table-overflow-hidden'
                                onClick={() => {
                                    // row 전체 데이터 저장
                                    setClickData(data);

                                    // 서버에서 받아온 data.date가 YYYYMM 형태라면, YYYY-MM으로 변환
                                    // 만약 이미 YYYY-MM 형태라면 그대로 setUploadDate(data.date) 하시면 됩니다.
                                    if (data.date && data.date.length === 6) {
                                        // ex) "202501" -> "2025-01"
                                        const year = data.date.slice(0, 4);
                                        const month = data.date.slice(4);
                                        setUploadDate(`${year}-${month}`);
                                    } else {
                                        setUploadDate(data.date ?? '');
                                    }

                                    // 이미지 URL이 완전한 경로가 아닐 경우, 서버 경로 붙이기 등 필요한 처리를 해주세요.
                                    // 예: setImagePreview(`${process.env.REACT_APP_API}/uploads/${data.imageUrl}`);
                                    // 여기서는 data.imageUrl이 바로 접근 가능한 URL이라고 가정
                                    setImagePreview(data.imageUrl || null);
                                    setImageFile(null); // 기존 file 객체 초기화
                                }}
                            >
                                {data.imageUrl}
                            </div>
                        ),
                        width: "250px",
                        textAlign: "left"
                    },
                    {
                        no: 4,
                        text: data.pg,
                        width: "120px",
                        textAlign: "center"
                    },
                    {
                        "no": 5, "text": (
                            <div className="flex justify-center items-center">
                                <a className="delete flex items-center text-danger pointer" onClick={() => onDeleteData(data.id)}>
                                    <SquareX width={15} height={15} /> 삭제
                                </a>
                            </div>), "width": "80px", "textAlign": "center"
                    }
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listData])

    const onDeleteData = async (e) => {
        if (window.confirm("삭제하시겠습니까?") === true) {
            await axios.delete(process.env.REACT_APP_API + "/api/card-fee", {
                data: { id: e }, // ✅ 삭제할 데이터 body에 넣음
                withCredentials: true,
            })
                .then((response) => {
                    console.log(response.data)
                    let tmp = response?.data
                    if (tmp?.code < 2000) {
                        setImagePreview(null)
                        setReload(e => !e)
                    } else {
                        setMessage({ msg: "삭제에 실패했습니다." })
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }

    // 날짜 선택 관련
    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState("")
    const [nextDate, setNextDate] = useState("")

    useEffect(() => {
        if (tabBtn === 0) {
            pickerRef.current = new Litepicker({
                element: inputRef.current,
                lang: "ko",
                singleMode: false,
                format: 'YYYY-MM-DD',
                numberOfMonths: 2,
                numberOfColumns: 2,
                showWeekNumbers: true,
                dropdowns: {
                    minYear: 2020,
                    maxYear: 2030,
                    months: true,
                    years: true,
                },
                setup: (picker) => {
                    picker.on('selected', (start, end) => {
                        setPreDate(start.format('YYYY-MM-DD'));
                        setNextDate(end.format('YYYY-MM-DD'));
                    });
                }
            });

            return () => {
                pickerRef.current?.destroy();
            };
        }
    }, [tabBtn]);

    useEffect(() => {
        // 초기 날짜 범위 설정
        const today = dayjs().format('YYYY-MM-DD');
        setDateRange(today, today);
    }, [])

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // =============================
    // 이미지 파일 핸들링 (Drag & Drop, File input)
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            previewImage(file);
            setImageFile(file);
        }
    };

    const previewImage = (file) => {
        const reader = new FileReader();
        reader.onload = () => {
            setImagePreview(reader.result);
        };
        reader.readAsDataURL(file);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith('image/')) {
            previewImage(file);
            setImageFile(file);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    // 업로드 취소 (미리보기 초기화)
    const handleCancel = () => {
        setImagePreview(null);
        setImageFile(null);
        fileInputRef.current.value = null; // input 초기화
        setUploadDate('');
        setClickData([]); // 클릭된 데이터 초기화 (선택 해제)
    };

    // 실제 업로드(등록) 처리
    const handleUpload = async () => {
        if (!imageFile) {
            alert("이미지를 선택해주세요.");
            return;
        }
        if (!uploadDate) {
            alert("날짜(년/월)를 선택해주세요.");
            return;
        }

        try {
            // 서버에서 multipart/form-data로 받을 수 있도록 FormData 사용
            const formData = new FormData();
            formData.append("pg", "다우");
            formData.append("file", imageFile);

            // YYYY-MM 형태를 YYYYMM 형태로 변환 (ex. 2025-03 -> 202503)
            const dateYYYYMM = uploadDate.replace('-', '');
            formData.append("date", dateYYYYMM);

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/card-fee",
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                // 업로드 성공 후 초기화
                setReload(e => !e);
                handleCancel();
            } else {
                setMessage({ msg: "파일 업로드에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            alert("업로드 중 오류가 발생했습니다.");
        }
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <MessageModal message={message} />

            {/* 검색 영역 */}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"만료일자"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            {/* 메인 테이블 + 업로드 섹션 */}
            <div className="intro-y box intro-padding">
                <div className='div-flex-2' style={{ gap: "20px" }}>
                    {/* 왼쪽: 리스트 */}
                    <div className='div-flex-2-1' style={{ height: "auto" }}>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineData}
                            filter_tableBodyData={filter_tableBodyData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            change={tabBtn}
                        />
                    </div>

                    {/* 오른쪽: 업로드 & 미리보기 */}
                    <div style={{ maxWidth: "450px", width: "100%" }}>
                        {/* 업로드 영역 */}
                        <div
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                            onClick={() => fileInputRef.current.click()}
                            style={{
                                border: '2px dashed #aaa',
                                borderRadius: '10px',
                                padding: '20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: '#fafafa',
                            }}
                        >
                            <p>파일을 이곳에 드래그하거나 클릭해서 업로드하세요</p>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </div>

                        {/* 선택된(로컬 업로드 or 클릭한) 이미지 미리보기 + 날짜 입력 + 등록/취소 버튼 */}
                        {imagePreview && (
                            <div style={{ marginTop: '20px' }}>
                                <h4>미리보기</h4>
                                <img
                                    src={imagePreview}
                                    alt="업로드 이미지 미리보기"
                                    style={{
                                        maxWidth: '100%',
                                        border: 'none',
                                        borderRadius: '8px'
                                    }}
                                />
                                <div
                                    style={{
                                        marginTop: '10px',
                                        display: 'flex',
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }}
                                >
                                    {/* 날짜(년/월) 선택 input */}
                                    <div style={{ fontSize: '13px'}}>
                                        <label>업로드 날짜(년/월): </label>
                                        <input
                                            type="month"
                                            value={uploadDate}
                                            onChange={(e) => setUploadDate(e.target.value)}
                                            style={{
                                                marginLeft: '10px',
                                                padding: '4px',
                                                fontSize: '12px',
                                            }}
                                        />
                                    </div>

                                    {/* 등록/취소 버튼 */}
                                    <div style={{ display: 'flex', gap: '10px' }}>
                                        {
                                            clickData.length === 0
                                                ?
                                                <button
                                                    onClick={handleUpload}
                                                    style={{
                                                        padding: '8px 16px',
                                                        backgroundColor: '#43a047',
                                                        color: '#fff',
                                                        border: 'none',
                                                        borderRadius: '5px',
                                                        cursor: 'pointer',
                                                        height: '40px'
                                                    }}
                                                >
                                                    등록
                                                </button>
                                                :
                                                ""
                                        }
                                        <button
                                            onClick={handleCancel}
                                            style={{
                                                padding: '8px 16px',
                                                backgroundColor: '#e53935',
                                                color: '#fff',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                                height: '40px'
                                            }}
                                        >
                                            취소
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FeeNotice